import { useState, useRef } from "react";
import Modal from "../../../../components/Modal";
import { MassUploadTable } from "./MassUploadTable";
import ShowButton from "../../../../components/ShowButton";
import UploadFileButton from "../../../../components/UploadFileButton";
import { ArrowDownCircleIcon } from "@heroicons/react/24/solid";
import { toast } from "../../../../components/toastNotification";
import EditButton from "../../../../components/EditButton";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { useRecoilState, useRecoilValue } from "recoil";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import {
  leAllMassUploadData,
  leEditMassUpload,
  leMassUploadData,
  leRowData,
  rowForEditLeasedEquipment,
} from "../atom/atom";
import useUploadMassUploadFile from "../hooks/useUploadMassUploadFile";

import CloseIconButton from "../../../../components/CloseIconButton";
import { downloadLeasedEquipmentTemplate } from "actions/CarrierAgreementMgmt/LeasedEquipment";
import LeasedEquipmentModalDetails from "../view/LeasedEquipmentModalDetails";
import { LeasedEquipmentForm } from "../forms/LeasedEquipmentForm";

export const MassUpload = ({
  isOpen,
  setMassUploadModal,
  agmtRefetch,
  mode,
}) => {
  const [allMassUploadData, setAllMassUpload] =
    useRecoilState(leAllMassUploadData);
  const [massUploadData, setMassUploadData] = useRecoilState(leMassUploadData);
  const [isEditMassUpload, setEditMassUpload] =
    useRecoilState(leEditMassUpload);
  const [rowToEdit, setRowToEdit] = useRecoilState(rowForEditLeasedEquipment);
  const [leDetails, setLeDetails] = useRecoilState(leRowData);
  const isEditState = useRecoilValue(leEditMassUpload);
  const [isShowState, setShow] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [toggleClear, setToggleCleared] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const { mutateAsync: uploadLeasedEquipment, isLoading } =
    useUploadMassUploadFile();

  const inputRef = useRef();
  const user = useRecoilValue(accountAtom);

  const [isEdit, setIsEdit] = useState(false);

  const openRowModal = (row, isEdit) => {
    setIsEdit(isEdit);

    if (isEdit) {
      setRowToEdit(row);
    } else {
      setLeDetails(row);
    }
    setEditMassUpload(isEdit);
    setShow(true);
  };

  const closeRowModal = () => {
    setShow(false);
    setEditMassUpload(false);
  };

  const officeColumns = [
    {
      name: "Office Name",
      cell: (row) => {
        return <div className="text-start">{row.officeName}</div>;
      },
    },

    {
      name: "Office Code",
      cell: (row) => {
        return <div className="text-start">{row.officeCode}</div>;
      },
    },

    {
      name: "Office #",
      cell: (row) => {
        return <div className="text-start">{row.officeNumber}</div>;
      },
    },

    {
      name: "Address",
      cell: (row) => {
        return <div className="text-start">{row.address}</div>;
      },
    },
    {
      name: "City",
      cell: (row) => {
        return <div className="text-start">{row.city}</div>;
      },
    },
    {
      name: "State",
      cell: (row) => {
        return <div className="text-start">{row.state}</div>;
      },
    },

    {
      name: "Zip",
      cell: (row) => {
        return <div className="text-start">{row.zip}</div>;
      },
    },
  ];

  const vendorColumns = [
    {
      name: "Vendor Name",
      cell: (row) => {
        return <div className="text-start">{row.vendorStorage}</div>;
      },
    },
    {
      name: "Vendor Code",
      cell: (row) => {
        return <div className="text-start">{row.vendorStorageCode}</div>;
      },
    },
  ];
  const findingsColumn = [
    {
      name: "Findings",
      cell: (row) => {
        return <div>{row.condition}</div>;
      },
    },
  ];

  const baseColumns = [
    {
      name: "Type",
      cell: (row) => {
        return <div className="text-start">{row.type}</div>;
      },
    },
    {
      name: "Make",
      cell: (row) => {
        return <div className="text-start">{row.make}</div>;
      },
    },

    {
      name: "Model",
      cell: (row) => {
        return <div className="text-start">{row.model}</div>;
      },
    },

    {
      name: "Supply Alert Profile",
      cell: (row) => {
        return <div className="text-start">{row.supplyAlertProfile}</div>;
      },
    },
    {
      name: "Serial Number",
      cell: (row) => {
        return <div className="text-start">{row.serialNumber}</div>;
      },
    },

    {
      name: "Customer Number",
      cell: (row) => {
        return <div className="text-start">{row.customerNumber}</div>;
      },
    },
    {
      name: "Vendor Location No",
      cell: (row) => {
        return <div className="text-start">{row.vendorLocationNumber}</div>;
      },
    },

    {
      name: "Purchasing Vendor",
      cell: (row) => {
        return <div className="text-start">{row.purchasingVendorNumber}</div>;
      },
    },
    {
      name: "Status",
      cell: (row) => {
        return <div className="text-start">{row.status}</div>;
      },
    },
    {
      name: "Servicing Dealer",
      // center: "true",
      cell: (row) => {
        return <div className="text-start">{row.servicingDealer}</div>;
      },
    },

    {
      name: "Actions",
      center: "true",
      cell: (row) => {
        return (
          <div className=" flex flex-row justify-center items-center opacity-100 space-x-1  overflox-x-hidden">
            <div className="flex flex-col gap-y-1">
              <ShowButton
                className={
                  (isShowState || isEditMassUpload || selectedRows?.length > 0
                    ? "opacity-50"
                    : "opacity-100") + ""
                }
                disabled={
                  isEditMassUpload || isShowState || selectedRows?.length > 0
                }
                buttonText="Show"
                onClick={() => {
                  openRowModal(row, false);
                }}
              />
              <EditButton
                className={
                  (isShowState || selectedRows?.length > 0
                    ? "opacity-50"
                    : "opacity-100") + ""
                }
                disabled={
                  isEditMassUpload || isShowState || selectedRows?.length > 0
                }
                buttonText="Edit"
                onClick={() => {
                  openRowModal(row, true);
                }}
              />
            </div>
          </div>
        );
      },
    },
  ];

  const columns =
    mode === "office"
      ? [...findingsColumn, ...officeColumns, ...baseColumns]
      : [...findingsColumn, ...vendorColumns, ...baseColumns];

  const attachFile = (e) => {
    handleReset();
    const forUpload = new FormData();
    forUpload.append("file", e.target.files[0]);
    uploadFile(forUpload);
    e.target.value = null;
  };

  const isOffice = mode === "office";
  const uploadFile = (forUpload) => {
    uploadLeasedEquipment(
      { file: forUpload, isOffice },
      {
        onSuccess: (res) => {
          if (res) {
            if (res.status === 200) {
              if (res.data?.length > 0) {
                const uploadedData = res.data.map((d, index) => {
                  return {
                    ...d,
                    expandRow: false,
                  };
                });
                setMassUploadData(uploadedData);
                setAllMassUpload(uploadedData);
              } else {
                toast.fire(
                  "Uploading Leased Equipment",
                  "File has no data to read",
                  "warning"
                );
                setMassUploadData([]);
                setAllMassUpload([]);
              }
            } else {
              if (res.data) {
                const errorMessage = res.data.message
                  ? res.data.message
                  : res.data;
                toast.fire(
                  "Uploading Leased Equipment Failed",
                  // errorMessage,
                  "Invalid Template",
                  "error"
                );
                setMassUploadData([]);
                setAllMassUpload([]);
              }
            }
          }
        },
        onError: (err) => {
          toast.fire("Uploading Leased Equipment Failed", err, "error");
          setMassUploadData([]);
          setAllMassUpload([]);
        },
      }
    );
    if (inputRef.current) {
      inputRef.current.value = null;
    }
    updatedDataHandler("All", 0);
  };

  const filters = ["All", "Valid", "Invalid"];
  const updatedDataHandler = (options, index = 0) => {
    if (options === "All") {
      setMassUploadData(allMassUploadData);
    }
    if (options === "Valid") {
      setMassUploadData(
        allMassUploadData.filter((d) => d.condition.toLowerCase() === "valid")
      );
    }
    if (options === "Invalid") {
      setMassUploadData(
        allMassUploadData.filter((x) => x.condition.toLowerCase() !== "valid")
      );
    }
    setActiveTab(index);
  };
  const DownloadTemplate = () => {
    downloadLeasedEquipmentTemplate(isOffice).then((content) => {
      if (content.status === 200) {
        var fileName = "";

        if (isOffice) {
          fileName = "MassUploadLeasedEquipmentOfficeTemplate.xlsx";
        } else {
          fileName = "MassUploadLeasedEquipmentVendorStorageTemplate.xlsx";
        }

        var url = window.URL.createObjectURL(content.data);

        let tempLink = document.createElement("a");
        tempLink.href = url;
        tempLink.setAttribute("download", fileName);
        tempLink.click();

        toast.fire("Success", "File Downloaded Successfully", "success");
      }
      if (content.status === 404) {
        toast.fire("Error Downloading File:", "File not found", "error");
      }
    });
  };

  const handleSelectedRowsChange = (selected) => {
    setSelectedRows(selected.selectedRows);
  };

  const handleDelete = () => {
    const ids = selectedRows.map((d) => d.id);

    const updatedAll = allMassUploadData.filter((d) => !ids.includes(d.id));
    setAllMassUpload(updatedAll);

    const currentFilter = filters[activeTab]; // All, Valid, or invalid
    let updatedFiltered = [];

    if (currentFilter === "All") {
      updatedFiltered = updatedAll;
    } else if (currentFilter === "Valid") {
      updatedFiltered = updatedAll.filter(
        (d) => d.condition?.toLowerCase?.() === "valid"
      );
    } else if (currentFilter === "Invalid") {
      updatedFiltered = updatedAll.filter(
        (d) => d.condition?.toLowerCase?.() !== "valid"
      );
    }

    setMassUploadData(updatedFiltered);

    setToggleCleared(!toggleClear);
    setShow(false);
    setOpenModal(false);
    setSelectedRows([]);

    toast.fire(
      "Delete Leased Equipment",
      "Leased Equipment successfully removed",
      "success"
    );
  };

  const handleReset = () => {
    setMassUploadData([]);
    setAllMassUpload([]);
    setEditMassUpload(false);
    setSelectedRows([]);
    setShow(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        handleReset();
        setMassUploadModal(false);
        setOpenModal(false);
      }}
      closeOutside={false}
      hasCloseButton={true}
      // width="full"
      // className={" w-[1200px]"}
      className={" w-[80%] mx-auto"}
    >
      <>
        <>
          <div className="font-bold text-xl flex items-center border-b-4 border-secondary py-4">
            <div className="text-base text-primary font-bold">
              {/* Leased Equipment Mass Upload */}
              {mode === "vendor"
                ? "Leased Equipment Mass Upload Vendor Storage"
                : "Leased Equipment Mass Upload Office"}
            </div>
            {!isShowState && !isEditState && (
              <div className="ml-auto flex items-center">
                <button
                  onClick={DownloadTemplate}
                  className="hover:scale-90 transition duration-500 bg-tranparent mr-2 border-secondary shadow-md hover:bg-secondary text-secondary group relative flex justify-center items-center py-1 px-3 border text-xs font-medium rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary focus:ring-opacity-70"
                >
                  <ArrowDownCircleIcon className="h-4 w-4 mr-2" />
                  Template
                </button>
                <UploadFileButton onChange={attachFile} disabled={false} />
              </div>
            )}
          </div>
          {isShowState ? (
            <div className="relative mx-auto p-4 mt-4 box-shadow rounded bg-white">
              <CloseIconButton onClick={() => closeRowModal(false)} />

              {isEdit ? (
                <LeasedEquipmentForm
                  getAgmtRefetch={agmtRefetch}
                  isModalEdit
                  isEdit
                  // closeModal={closeRowModal()}
                  closeModal={() => closeRowModal(false)}
                  isOffice={isOffice}
                />
              ) : (
                <LeasedEquipmentModalDetails
                  leDetails={leDetails}
                  isOffice={isOffice}
                />
              )}
            </div>
          ) : (
            <>
              <div className="flex my-2">
                {filters.map((filter, index) => (
                  <button
                    key={index}
                    onClick={() => updatedDataHandler(filter, index)}
                    className={`${
                      activeTab === index &&
                      "border-b-4 border-primary border-primary font-bold bg-gray-100"
                    }
                    ${
                      selectedRows?.length > 0 &&
                      "opacity-40 cursor-not-allowed"
                    }  w-1/12 text-sm text-tertiary py-2 px-4`}
                    disabled={selectedRows?.length > 0}
                  >
                    {filter}
                  </button>
                ))}
              </div>

              {massUploadData?.length > 0 && !isEditMassUpload && (
                <div className="text-secondary italic text-xs3 mx-2">
                  <p className="font-bold italic inline-block mr-1">Note: </p>
                  Tick the box to delete some data.
                </div>
              )}

              <div className="mt-3 ">
                {massUploadData && columns ? (
                  <MassUploadTable
                    data={massUploadData}
                    columns={columns}
                    selectedRows={selectedRows}
                    onSelectedRowsChange={handleSelectedRowsChange}
                    setOpenModal={setOpenModal}
                    setMassUploadModal={setMassUploadModal}
                    handleReset={handleReset}
                    clearSelectedRows={toggleClear}
                    isEdit={isEditMassUpload}
                  />
                ) : (
                  <div>Loading table...</div>
                )}

                {/* <div>Loading table...</div> */}
              </div>
            </>
          )}
        </>
        <ConfirmBoxDelete
          ModalTitle="Delete Leased Equipment"
          qConfirmation={"Are you sure you want to delete leased equipment(s)?"}
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onClickFunction={handleDelete}
        />
      </>
    </Modal>
  );
};
